module.exports = __webpack_public_path__ + "img/label-copy-29.5608e127.svg";